/**
 * What's New API module — curated dashboard product-update modal.
 */
import { fetchApi } from './client';
import { log } from '@/lib/logger';
import { MUTATION_TIMEOUT_MS, SCREEN_READ_TIMEOUT_MS } from './requestTimeout';

log.info('[api/whatsNew] Module loaded');

export interface WhatsNewItem {
  text: string;
  url?: string;
}

export interface WhatsNewRelease {
  id: string;
  title: string;
  dateLabel: string;
  heroImageUrl: string | null;
  headline: string;
  body: string;
  items: WhatsNewItem[];
  ctaLabel: string | null;
  ctaUrl: string | null;
}

export type WhatsNewArchiveEntry = WhatsNewRelease & { read: boolean };

export const whatsNewApi = {
  getCurrent: (token: string | undefined): Promise<WhatsNewRelease | null> =>
    fetchApi<WhatsNewRelease | null>('/whats-new/current', { token, timeoutMs: SCREEN_READ_TIMEOUT_MS }),

  markRead: (token: string | undefined, id: string): Promise<{ ok: true }> =>
    fetchApi<{ ok: true }>(`/whats-new/${id}/read`, { token, method: 'POST', timeoutMs: MUTATION_TIMEOUT_MS }),

  getArchive: (token: string | undefined): Promise<WhatsNewArchiveEntry[]> =>
    fetchApi<WhatsNewArchiveEntry[]>('/whats-new/archive', { token, timeoutMs: SCREEN_READ_TIMEOUT_MS }),
};
